import Vue from "vue";
import Router from "vue-router";
import { GetCookie } from "@/utils/CookieUtil";
import jwt_decode from "jwt-decode";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      beforeEnter: (to, from, next) => {
        if (to.path.indexOf("api") > -1 || to.path.indexOf("uploads") > -1) {
          next();
        } else {
          from.meta.pageNotFound = true;
          next("/");
        }
      },
    },
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
    },
    // {
    //   path: "/inscreva-se",
    //   name: "inscreva-se",
    //   component: () => import("@/views/Login/Login.vue"),
    //   meta: {
    //     requiresNoAuth: true,
    //   },
    // },
    // {
    //   path: "/cadastre-se",
    //   name: "Cadastro",
    //   component: () => import("@/views/Cadastro.vue"),
    // },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/Login/Login.vue"),
      meta: {
        requiresNoAuth: true,
      },
    },
    {
      path: "/esqueci-senha",
      name: "Esqueci-senha",
      component: () => import("@/views/EsqueciSenha.vue"),
    },
    {
      path: "/recuperar-senha",
      name: "Trocar-senha",
      component: () => import("@/views/TrocarSenha.vue"),
      meta: {
        requiresToken: true,
      },
    },
    {
      path: "/palestras",
      name: "Palestras",
      component: () => import("@/views/Palestras/Palestras.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ao-vivo",
      name: "AoVivo",
      component: () => import("@/views/AoVivo.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/aguardando",
      name: "Aguardando",
      component: () => import("@/views/Aguardar-ao-vivo.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/usuario",
      name: "inscritas",
      component: () => import("./components/UserRouter.vue"),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "palestras-inscritas",
          name: "inscritas",
          component: () => import("@/views/Palestras/Inscritas.vue"),
        },
      ],
    },
    {
      path: "/admin",
      name: "AdminRouter",
      component: () => import("./components/AdminRouter.vue"),
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
      },
      children: [
        {
          path: "inscritos/:idPalestra",
          name: "inscritos",
          component: () => import("@/views/Dashboard/inscritos.vue"),
          meta: {
            tipoNavbar: "navbarAdmin",
          },
        },
        {
          path: "usuarios",
          name: "usuarios",
          component: () => import("@/views/Dashboard/usuarios.vue"),
          meta: {
            tipoNavbar: "navbarAdmin",
          },
        },
        {
          path: "adicionar-palestra",
          name: "adicionar-palestra",
          component: () =>
            import("@/views/Dashboard/AdicionarEditarPalestra.vue"),
          meta: {
            tipoNavbar: "navbarAdmin",
          },
        },
        {
          path: "editar-palestra/:idPalestra",
          name: "editar-palestra",
          component: () =>
            import("@/views/Dashboard/AdicionarEditarPalestra.vue"),
          meta: {
            tipoNavbar: "navbarAdmin",
          },
        },
        {
          path: "palestrantes",
          name: "palestrantes",
          component: () => import("@/views/Dashboard/Palestrantes.vue"),
          meta: {
            tipoNavbar: "navbarAdmin",
          },
        },
        {
          path: "adicionar-palestrante",
          name: "adicionar-palestrante",
          component: () =>
            import("@/views/Dashboard/AdicionarEditarPalestrante.vue"),
          meta: {
            tipoNavbar: "navbarAdmin",
          },
        },
        {
          path: "editar-palestrante/:idPalestrante",
          name: "editar-palestrante",
          component: () =>
            import("@/views/Dashboard/AdicionarEditarPalestrante.vue"),
          meta: {
            tipoNavbar: "navbarAdmin",
          },
        },
        {
          path: "palestras",
          name: "palestras",
          component: () => import("@/views/Dashboard/Palestras.vue"),
          meta: {
            tipoNavbar: "navbarAdmin",
          },
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresToken)) {
    if (to.query.token) {
      next();
    } else {
      next("/");
    }
  } else if (to.matched.some((record) => record.meta.requiresAdmin)) {
    if (GetCookie("token")) {
      const user = jwt_decode(GetCookie("token"));
      if (user && user.role == "admin") {
        next();
      } else {
        next("/");
      }
    } else {
      next("/");
    }
  } else if (to.matched.some((record) => record.meta.requiresNoAuth)) {
    if (GetCookie("token")) {
      next("/palestras");
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (GetCookie("token")) {
      next();
    } else {
      next("/");
    }
  } else if (to.matched.some((record) => record.meta.pageNotFound)) {
    next("/");
  } else {
    next();
  }
});

export default router;
